import React from 'react';
import styled from 'styled-components';
import { theme, toRem } from 'design';
import { HR, Text } from '../Typography';

interface SectionConditionalProps {
  condition: 'or' | 'and';
  color?: string;
  width?: number;
}

const Layout = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  width: 100%;

  p {
    color: ${theme.color.neutral[400]};
    margin: ${toRem(22)} ${toRem(16)};
    text-transform: uppercase;
    font-weight: ${theme.font.weight.semiBold};
  }
`;

const SectionConditional = ({ condition, width, color }: SectionConditionalProps) => (
  <Layout>
    <HR width={width} color={color} />
    <Text fontWeight="semibold"> {condition} </Text>
    <HR width={width} color={color} />
  </Layout>
);

export default SectionConditional;
